import React from 'react';
import { Icon } from './Icon.js';
export const IconDogHouse = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 21V11L22 10.5V9.5L12 2L2 9.5V10.5L4 11V21", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 21V16C8 13.7909 9.79086 12 12 12C14.2091 12 16 13.7909 16 16V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M2 21H22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M11 8H13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDogHouse.js.map